// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__Ok-+r","action":"Disclaimer_action__-v+YL","btn":"Disclaimer_btn__y3pQ+"};